export default {"src":"/_next/static/media/ScoliosisandKyphosis.85f0fea0.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};